module.exports = __webpack_public_path__ + "img/10-girl.d0d56359.svg";